import ProcurementsTable from './ProcurementsListTable';
import ProcurementsListPageHeader from './ProcurementsListPageHeader';

export { ProcurementsTable, ProcurementsListPageHeader };
